import React from 'react';
import { FormikProps } from 'formik';

interface FormValues {
  meal_plan: string[];
  free_cancellation: string;
  room_type: string[];
}
interface FilterHeaderProps {
    onClearAll: () => void;
  }
  
const FilterHeader: React.FC<FilterHeaderProps> = ({ onClearAll }) => {
  return (
    <>
      <div className="col-auto">
        <h6 className="fw-bold">Filter By</h6>
      </div>
      <div className="col-auto">
        <button
          type="button"
          className="text-12 button p-2 -dark-1 bg-blue-1 text-white"
          onClick={onClearAll}
        >
          Clear all
        </button>
      </div>
    </>
  );
};

export default FilterHeader;